// v1.4.1 C6: where a bell row goes. The API's `link` (apps/notifications/
// targets.py — computed on read from the type and ids, for the reader's
// role) wins; the two deep links the bell knew before C6 stay as the fallback
// for a payload the server could not route. null = mark read only.
export function notificationHref(n) {
  if (!n) return null;
  if (typeof n.link === 'string' && n.link.startsWith('/') && !n.link.startsWith('//')) return n.link;
  const p = n.data_payload || {};
  if (n.notification_type === 'new_message' && p.conversation) return `/messages?conversation=${p.conversation}`;
  if (n.notification_type === 'new_enquiry') return p.enquiry_id ? `/enquiries/${p.enquiry_id}` : '/enquiries';
  return null;
}
